var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappDesativo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "black",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 24L9.13085 19.8935C8.43171 18.6882 8.06495 17.3232 8.06877 15.9278C8.06877 11.5551 11.6447 8 16.0344 8C18.1662 8 20.1681 8.82509 21.6695 10.3232C23.1748 11.8213 24.0038 13.8137 24 15.9316C24 20.3042 20.4241 23.8593 16.0306 23.8593H16.0267C14.6934 23.8593 13.383 23.5247 12.2178 22.8935L8 24ZM12.4202 21.4601L12.6609 21.6046C13.6772 22.2053 14.8424 22.5209 16.0306 22.5247H16.0344C19.6829 22.5247 22.6552 19.5703 22.6552 15.9354C22.6552 14.1749 21.9675 12.5209 20.7182 11.2738C19.4689 10.0266 17.8032 9.34221 16.0344 9.34221C12.3859 9.3384 9.41356 12.2928 9.41356 15.9278C9.41356 17.1711 9.76122 18.384 10.426 19.4335L10.5826 19.6844L9.91404 22.1141L12.4202 21.4601Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0439 12.6122C13.8949 12.2814 13.7382 12.2738 13.5969 12.27C13.4823 12.2662 13.3485 12.2662 13.2148 12.2662C13.0811 12.2662 12.8672 12.3156 12.6838 12.5133C12.5004 12.711 11.9885 13.1901 11.9885 14.1673C11.9885 15.1407 12.7029 16.0837 12.8022 16.2167C12.9015 16.3498 14.1814 18.4145 16.2024 19.2091C17.8834 19.8707 18.2272 19.7377 18.5902 19.7034C18.9531 19.6692 19.7669 19.2243 19.935 18.7605C20.0992 18.2966 20.0992 17.9012 20.0496 17.8175C19.9999 17.7339 19.8662 17.6844 19.6675 17.5856C19.4689 17.4867 18.4908 17.0076 18.3075 16.9392C18.1241 16.8745 17.9904 16.8403 17.8605 17.038C17.7268 17.2358 17.3447 17.6806 17.2301 17.8137C17.1155 17.9468 16.9971 17.962 16.7984 17.8631C16.5997 17.7643 15.9579 17.5551 15.1976 16.8783C14.6055 16.3536 14.2043 15.7034 14.0897 15.5057C13.9751 15.308 14.0782 15.2015 14.1776 15.1027C14.2654 15.0152 14.3762 14.8707 14.4756 14.7567C14.5749 14.6426 14.6093 14.5589 14.6742 14.4259C14.7392 14.2928 14.7086 14.1787 14.6589 14.0799C14.6093 13.9848 14.2196 13.0038 14.0439 12.6122Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappDesativo);
export default __webpack_public_path__ + "static/media/Whatsapp-Desativo.6b5bbcf3.svg";
export { ForwardRef as ReactComponent };